/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Form, Icon } from 'semantic-ui-react';

class Password extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: 'password',
        };
    }

    showPassword = () => this.setState({ type: 'text' });
    hidePassword = () => this.setState({ type: 'password' });

    render() {
        const { type } = this.state;

        return (
            <div style={{ position: 'relative', width: '100%' }}>
                <Form.Input {...this.props} type={type} />
                <Icon
                    name="eye"
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '5px',
                        bottom: '6px',
                        transition: 'all 0.1s ease-in-out',
                        opacity: type === 'text' ? 1 : 0.8,
                    }}
                    onMouseDown={() => this.showPassword()}
                    onMouseUp={() => this.hidePassword()}
                    size="large"
                />
            </div>
        );
    }
}

export default Password;
